import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Layout from "../../../components/dashboard/Layout";
import AddSubject from "../../../containers/superadmin/subject/models/add-subject";
import SearchBar from "../../../containers/superadmin/subject/searchbar";
import SubjectsTable from "../../../containers/superadmin/subject/table";
import { getAllSubjectsRequest } from "../../../modules/superadmin-modules/subjects/Actions";

const Subjects = () => {
  const dispatch = useDispatch();
  const model = useSelector((state) => state.model);
  const [isAdd, setAdd] = useState(false);
  const [selectedData, setSelectedData] = useState({});

  useEffect(() => {
    dispatch(getAllSubjectsRequest());
  }, []);

  return (
    <Layout>
      <SearchBar setAdd={setAdd} setSelectedData={setSelectedData} />
      <SubjectsTable setAdd={setAdd} setSelectedData={setSelectedData} />
      <AddSubject
        isAdd={isAdd}
        data={selectedData}
        setSelectedData={setSelectedData}
      />
    </Layout>
  );
};

export default Subjects;
